import create from "zustand";
import {
  DEFAULT_IB_PRODUCT_FEATURES,
  normalizeIbProductFeatures,
} from "../Utils/ibProductFeatures";

const featuresEqual = (a, b) =>
  a?.pix === b?.pix &&
  a?.cards === b?.cards &&
  a?.stables === b?.stables &&
  a?.fiat === b?.fiat &&
  a?.carteira === b?.carteira;

/**
 * Active-account product features for Carteira menu / route gates.
 * Updated from `/v1/ib/accounts/me` and account list / switch.
 * Call setFeatures from effects / async handlers — never during render.
 */
export const useIbProductFeaturesStore = create((set) => ({
  features: { ...DEFAULT_IB_PRODUCT_FEATURES },
  loaded: false,
  setFeatures: (raw) =>
    set((state) => {
      const features = normalizeIbProductFeatures(raw);
      if (state.loaded && featuresEqual(state.features, features)) {
        return state;
      }
      return { features, loaded: true };
    }),
}));
